import { useEffect, useState } from "react";
import Lenis from "lenis";
import { PdpDataProvider } from "@/components/pdp/PdpDataContext";
import MegaHeaderV3 from "@/components/home/MegaHeaderV3";
import RiversolFooter from "@/components/pdp/RiversolFooter";
import PdpStickyNav from "@/components/pdp/PdpStickyNav";
import { PDP_3_4_SECTIONS } from "@/sections/pdp-3-4/sections";
import "@/styles/pdp-3-4.css";

// PDP 3.4 page shell: header → ordered sections (sections.js) → footer → sticky sub-nav.
// Mirrors the v34 branch of the shared PdpLayout exactly; smooth scroll is prototype-only.
export default function Pdp34Layout({ data }) {
  const [variant, setVariant] = useState(data.defaultVariant);
  const [qty, setQty] = useState(1);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.1, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)) });
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <PdpDataProvider data={data}>
      <div
        className="pdp-scope font-sans antialiased selection:bg-riversol-blue v31 v32 v33 v34"
        style={data.brandDark ? { "--brand-dark": data.brandDark } : undefined}
        data-testid="pdp-3-4"
      >
        <MegaHeaderV3 />
        <main>
          {PDP_3_4_SECTIONS.map(({ id, Component, props, settingFlag, needsCommerce }) => {
            if (settingFlag && data[settingFlag] === false) return null;
            const commerce = needsCommerce && id === "product-main" ? { variant, setVariant, qty, setQty } : {};
            return <Component key={id} {...props} {...commerce} />;
          })}
        </main>
        <RiversolFooter hp3 />
        <PdpStickyNav variant={variant} mobileCtaOnly />
      </div>
    </PdpDataProvider>
  );
}
